import {AgentIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {forwardRef, useCallback} from 'react'
import {useClickAnalytics} from '@github-ui/use-analytics'

export interface CopilotAssignmentButtonProps {
  onClick: () => void
}

export const CopilotAssignmentButton = forwardRef<HTMLButtonElement, CopilotAssignmentButtonProps>(({onClick}, ref) => {
  const {sendClickAnalyticsEvent} = useClickAnalytics()

  const handleClick = useCallback(() => {
    sendClickAnalyticsEvent({
      category: 'copilot_assignment',
      action: 'click_assign_to_copilot_button',
      label: 'ref_cta:assign_to_copilot',
    })
    onClick()
  }, [sendClickAnalyticsEvent, onClick])

  return (
    <Button ref={ref} leadingVisual={AgentIcon} size="small" block onClick={handleClick}>
      Assign to Copilot
    </Button>
  )
})

CopilotAssignmentButton.displayName = 'CopilotAssignmentButton'
